import { LitElement, html, css } from '@hh/global.js'

class HHLoadMore extends LitElement {
  static properties = {
    target: {
      type: String
    },
    disabled: {
      type: Boolean,
      reflect: true,
    },
    current: {
      type: Number
    },
    total: {
      type: Number
    },
    currentItems: {
      type: Number,
      attribute: 'current-items'
    },
    items: {
      type: Number
    },
    nextUrl: {
      type: String,
      attribute: 'next-url'
    }
  }

  constructor() {
    super()
  }

  connectedCallback() {
    this.loadMoreButton = this.querySelector('.js-load-more')

    super.connectedCallback()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  async onLoadMore () {
    this.loadMoreButton.setAttribute('disabled', true)

    const responseText = await fetch(this.nextUrl)
      .then(res => res.text())

    const html = new DOMParser().parseFromString(responseText, 'text/html')
    const destination = document.querySelector(this.target)
    const source = html.querySelector(this.target)

    destination.insertAdjacentHTML('beforeend', source.innerHTML)

    const loadMoreSource = html.querySelector(`hh-load-more[target="${this.target}"]`)
    const loadMoreDestination = document.querySelector(`hh-load-more[target="${this.target}"]`)

    loadMoreDestination.outerHTML = loadMoreSource.outerHTML
  }

  render() {
    return html`
      <div class="wrapper">
        <slot
          @loadMore="${this.onLoadMore}"
        ></slot>

        <div class="progress">
          <div class="indicator">${this.currentItems} of ${this.items}</div>

          <div class="progress-bar">
            <div class="progress-percent" style="width:${this.currentItems / this.items * 100}%">&nbsp;</div>
          </div>
        </div>
      </div>
    `
  }

  static styles = css`
    .wrapper,
    .progress {
      display: flex;
      align-items: center;
      flex-direction: column;
    }

    .wrapper {
      gap: var(--hh-space-xs);
    }

    .progress {
      gap: var(--hh-space-2xs);
    }

    .indicator {
      color: var(--hh-color-subdued);
      font: var(--hh-body-utility);
      letter-spacing: var(--hh-utility-letter-spacing);
    }

    .progress-bar {
      position: relative;
      border-radius: 0.3rem;
      height: 0.3rem;
      background-color: var(--hh-color-neutral);
      width: 11rem;
      margin: auto;
    }

    .progress-percent {
      position: absolute;
      border-radius: 0.3rem;
      height: 0.3rem;
      left: 0;
      background-color: var(--hh-color-brand-secondary);
    }
  `
}

customElements.define('hh-load-more', HHLoadMore)
